const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

async function supabaseRequest(path, options = {}) {
  if (!isSupabaseConfigured) {
    throw new Error('Supabase is not configured');
  }

  const response = await fetch(`${supabaseUrl}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      apikey: supabaseAnonKey,
      Authorization: `Bearer ${supabaseAnonKey}`,
      ...(options.headers || {}),
    },
  });

  const text = await response.text();
  const data = text ? JSON.parse(text) : null;

  if (!response.ok) {
    const message = data?.message || data?.error || response.statusText;
    throw new Error(message);
  }

  return { data, error: null };
}

export async function getSubscriber(token) {
  return supabaseRequest('/rest/v1/rpc/get_subscriber', {
    method: 'POST',
    body: JSON.stringify({ p_token: token }),
  });
}

export async function upsertSubscriber({ token, wishlist, email = null, notifyEnabled = true }) {
  return supabaseRequest('/rest/v1/rpc/upsert_subscriber', {
    method: 'POST',
    body: JSON.stringify({
      p_token: token,
      p_wishlist: wishlist,
      p_email: email,
      p_notify_enabled: notifyEnabled,
    }),
  });
}
